import React, { FC, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ArrivalStatCardProps {
  icon: ReactNode;
  label: string;
  value: string | number;
  badgeNode?: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
}

export const StatCard: FC<ArrivalStatCardProps> = ({
  icon,
  label,
  value,
  badgeNode,
  labelClassName,
  valueClassName,
}) => (
  <div className="border-base-border relative flex h-auto min-h-[72px] flex-1 flex-row items-center justify-between gap-2 overflow-visible rounded-2xl border bg-white px-4 py-3">
    {badgeNode ? (
      <div className="pointer-events-auto absolute top-[0px] right-[-7px] z-10 shrink-0">
        {badgeNode}
      </div>
    ) : null}
    <div className="flex min-w-0 items-center gap-2">
      {icon}
      <span
        className={cn(
          "text-foreground min-w-0 text-base break-normal",
          labelClassName,
        )}
      >
        {label}
      </span>
    </div>
    <span
      className={cn(
        "shrink-0 text-base font-bold text-[#10B981]",
        valueClassName,
      )}
    >
      {value}
    </span>
  </div>
);
